import { useEffect, useState } from 'react';
import { apiErrorHandling } from '../api/apierrorhandling';
import { getPayouts } from '../api/stoApi';
import { Payout } from '../models';
import { generalStore } from '../stores/GeneralStore';

export const usePayouts = (assetId: string | null, refresher?: boolean) => {
  const [payouts, setPayouts] = useState<Payout[] | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!assetId) return;
        const response = (await getPayouts(assetId)).data;
        setPayouts(response.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (!assetId) return;
    load();
  }, [assetId, refresher]);

  return payouts;
};
